import { useDispatch } from "react-redux";
import { userLogOut } from "../store/features/webUtilitiesSlice";

const Error = ({ errorMessage = null }) => {
  const dispatch = useDispatch();

  const handleLogout = async () => {
    await dispatch(userLogOut());
  };
  return (
    <div className="flex items-center justify-center h-screen bg-[#eee]">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-[red]">500</h1>
        <p className="mt-4 text-2xl text-[gray]">
          {errorMessage || "Oops! Something went wrong on our end."}
        </p>
        <p className="mt-2 text-gray-600 text-xs">
          Please try refreshing the page or come back later.
        </p>
        <a
          href="/"
          className="mt-6 inline-block px-6 text-orange bg-blue-500 rounded hover:bg-blue-600 transition"
        >
          Go Back Home
        </a>

        <p className="mb-0">-----Or-----</p>
        <span
          className="inline-block px-6 text-[red] bg-blue-500 rounded hover:bg-blue-600 transition cursor-pointer"
          onClick={handleLogout}
        >
          Log out
        </span>
      </div>
    </div>
  );
};
export default Error;
// "This email ID is blocked due to detected anomalies in the data. Please register again with a different email or reach out to support."; // For country null
